export { Heading, HeadingSizes, HeadingTags } from './heading';
export type { HeadingProps } from './heading';
export {HeadingInterface} from './heading.interface';